import { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"

import { useDemoDataToggle } from "../../../User/hooks/useDemoDataToggle"
import {
  getDescriptorsByEnrollment,
  getMoreDescriptorsByEnrollment
} from "../../../User/redux/user.thunks"

const useFetchDescriptorsList = ({
  enrollmentId,
  filters,
  PAGE_SIZE,
  skipFiltersUpdate,
  setSkipFiltersUpdate,
  userEnrollmentsFetching
}) => {
  const dispatch = useDispatch()
  const {
    descriptorsByEnrollment,
    descriptorsByEnrollmentFetching,
    moreDescriptorsByEnrollmentFetching
  } = useSelector((state) => state.user)
  const [page, setPage] = useState(1)
  const hasMore = descriptorsByEnrollment?.count > page * PAGE_SIZE
  const moreLoading = moreDescriptorsByEnrollmentFetching
  const loading = descriptorsByEnrollmentFetching
  const descriptors = descriptorsByEnrollment?.results || []
  const firstFiltersEffect = useRef(true)
  const { isShowDemoData } = useDemoDataToggle()

  const fetchDescriptorsReq = (params) => {
    dispatch(getDescriptorsByEnrollment(params))
  }

  const fetchMoreDescriptorsReq = (params) => {
    dispatch(getMoreDescriptorsByEnrollment(params))
  }

  const fetchDescriptors = () => {
    if (!enrollmentId) return
    fetchDescriptorsReq({
      enrollment_id: enrollmentId,
      descriptor: filters?.search || null,
      status: filters?.statuses?.join(",") || null,
      page: 1,
      page_size: PAGE_SIZE
    })
    setPage(1)
  }

  const fetchMore = () => {
    if (!enrollmentId || !hasMore || moreLoading) {
      return
    }
    fetchMoreDescriptorsReq({
      enrollment_id: enrollmentId,
      descriptor: filters?.search || null,
      status: filters?.statuses?.join(",") || null,
      page: page + 1,
      page_size: PAGE_SIZE
    })
    setPage((prevPage) => prevPage + 1)
  }

  // Initial fetch when enrollmentId is set or changed
  useEffect(() => {
    if (enrollmentId && !userEnrollmentsFetching) {
      fetchDescriptors()
    }
  }, [enrollmentId, isShowDemoData, userEnrollmentsFetching])

  // Update descriptors list when filters changed
  useEffect(() => {
    if (firstFiltersEffect.current) {
      firstFiltersEffect.current = false
      return
    }
    let timeout
    if (enrollmentId && !skipFiltersUpdate) {
      timeout = setTimeout(() => {
        fetchDescriptors()
      }, 300)
    }
    if (skipFiltersUpdate) {
      setSkipFiltersUpdate?.(false)
    }
    return () => clearTimeout(timeout)
  }, [filters])

  return { descriptors, fetchMore, hasMore, loading, moreLoading }
}

export default useFetchDescriptorsList
